import { type FC } from "react";
import { Grid } from "@mui/material";
import { AnalyticsMetric, type AnalyticsMetricData } from "./AnalyticsMetric";
import { ErrorMessage } from "@/shared/components";

interface AnalyticsMetricsProps {
  metrics: AnalyticsMetricData[];
  loading?: boolean;
  /**
   * Ошибка от useQuery блока метрик. Блок метрик — единственный виджет
   * вкладки, который грузится сразу (не через LazyAnalyticsWidget), поэтому
   * его ошибка особенно заметна: без неё блок показывал бы прочерки, как
   * будто за период просто нет данных (спека, раздел 5).
   */
  error?: unknown;
  xs?: number;
  sm?: number;
  md?: number;
}

export const AnalyticsMetrics: FC<AnalyticsMetricsProps> = ({
  metrics,
  loading,
  error,
  xs,
  sm,
  md,
}) => {
  if (error) {
    return <ErrorMessage error={error} />;
  }

  return (
    <Grid container spacing={1}>
      {metrics.map((metric) => (
        <Grid key={metric.label} size={{ xs, sm, md }}>
          <AnalyticsMetric loading={loading} metric={metric} />
        </Grid>
      ))}
    </Grid>
  );
};
